import PropTypes from "prop-types";
import styles from "./index.css";
import FromLabel from "../FromLabel";
import { withTranslation } from "../../../../../translation";

const getPriceClassName = (isPromotionalDiscount, isStrikethrough) => {
  if (isPromotionalDiscount) {
    return isStrikethrough
      ? styles.promotionalAmountStrikethrough
      : styles.promotionalAmount;
  }

  return isStrikethrough ? styles.saleAmountStrikethrough : styles.saleAmount;
};

const ReducedPrice = ({
  hasMultiplePrices,
  isMarkedDown,
  reducedPrice,
  isPromotionalDiscount,
  discountCode,
  formatTranslation,
  discountBenefitValue,
  discountedPrice,
  isStrikethroughInPromoContext,
}) => {
  const shouldShowFromLabel = hasMultiplePrices && !isPromotionalDiscount;
  const shouldStrikethrough = isStrikethroughInPromoContext;

  const useStrikethroughWrapper = shouldStrikethrough && shouldShowFromLabel;
  const priceClassName = getPriceClassName(
    isPromotionalDiscount,
    useStrikethroughWrapper ? false : shouldStrikethrough,
  );

  if (isPromotionalDiscount) {
    const withCodeMessage = discountCode
      ? `${formatTranslation("generic_with_code")}: ${discountCode}`
      : formatTranslation("generic_with_code");

    return (
      <span className={styles.reducedPrice}>
        {discountedPrice && (
          <span className={styles.promotionalAmount}>{discountedPrice}</span>
        )}
        <span className={styles.promoMessageWrapper}>
          <span className={styles.promotionalBenefit}>
            {" "}
            {discountBenefitValue}
          </span>
          <span className={styles.promoCode}> {withCodeMessage}</span>
        </span>
      </span>
    );
  }

  return (
    <span className={styles.reducedPrice}>
      {useStrikethroughWrapper ? (
        <span className={styles.strikethroughWrapper}>
          <FromLabel
            isMarkedDown={isMarkedDown}
            isPromotionalDiscount={isPromotionalDiscount}
          />
          <span className={styles.strikethroughPrice}>{reducedPrice}</span>
        </span>
      ) : (
        <>
          {shouldShowFromLabel && (
            <FromLabel
              isMarkedDown={isMarkedDown}
              isPromotionalDiscount={isPromotionalDiscount}
            />
          )}
          <span className={priceClassName}>{reducedPrice}</span>
        </>
      )}
    </span>
  );
};

export default withTranslation(ReducedPrice);

ReducedPrice.propTypes = {
  isMarkedDown: PropTypes.bool.isRequired,
  reducedPrice: PropTypes.string,
  hasMultiplePrices: PropTypes.bool.isRequired,
  isPromotionalDiscount: PropTypes.bool,
  discountCode: PropTypes.string,
  formatTranslation: PropTypes.func.isRequired,
  discountBenefitValue: PropTypes.string,
  discountedPrice: PropTypes.string,
  isStrikethroughInPromoContext: PropTypes.bool,
};

ReducedPrice.defaultProps = {
  isPromotionalDiscount: false,
  reducedPrice: null,
  discountCode: null,
  discountBenefitValue: null,
  discountedPrice: null,
  isStrikethroughInPromoContext: false,
};
